
import { ReactNode } from "react";
import { Button } from "@/components/ui/button";

interface EditorToolbarButtonProps {
  onClick: () => void;
  active: boolean;
  title: string;
  children: ReactNode;
  disabled?: boolean;
}

export const EditorToolbarButton = ({
  onClick,
  active,
  title,
  children,
  disabled = false,
}: EditorToolbarButtonProps) => {
  return (
    <Button
      onClick={onClick}
      variant={active ? "secondary" : "ghost"}
      size="sm"
      className="h-8 w-8 p-0"
      title={title}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};
